import React from "react";
import Image from "next/image";
import { Flex, ModalFooter, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomApprovalModal from "@/shared/components/custom-modal";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

// 원본 크기 — next/image가 종횡비를 잡는 데만 쓰고, 실제 표시는 폭 100%에 맞춘다.
const EXAMPLE_IMAGE_WIDTH = 1500;
const EXAMPLE_IMAGE_HEIGHT = 8010;

// 상단/하단 기본 이미지가 상품 상세 이미지 앞뒤에 배치되는 구조를 보여주는 예시 모달
function PathPickBasketBuyerInfoExampleModal({ isOpen, onClose }: Props) {
  const { t } = useI18nHelper();

  return (
    <CustomApprovalModal
      isOpen={isOpen}
      onClose={onClose}
      // 화면보다 넓으면 왼쪽이 스크롤로도 닿지 않아 화면 폭으로 클램프한다.
      minWidth={"min(560px, 92dvw)"}
      // 세로로 매우 긴 예시 이미지라 모달 안에서만 스크롤되게 한다.
      scrollBehavior={"inside"}
      isCentered={true}
    >
      <CustomApprovalModal.Header
        onClose={onClose}
        title={
          <Flex flexDirection={"column"} gap={"2px"}>
            <Text textStyle={"body-md-bold"} color={"#444444"}>
              {t("path_pick:basket.buyer_info.example_modal.title")}
            </Text>
            <Text textStyle={"body-sm-regular"} color={"#8F8F8C"}>
              {t("path_pick:basket.buyer_info.example_modal.description")}
            </Text>
          </Flex>
        }
      />
      <CustomApprovalModal.Body>
        <Image
          src={"/images/pathpick-buyer-info-image-example.webp"}
          alt={t("path_pick:basket.buyer_info.example_modal.title")}
          width={EXAMPLE_IMAGE_WIDTH}
          height={EXAMPLE_IMAGE_HEIGHT}
          style={{ width: "100%", height: "auto" }}
        />
      </CustomApprovalModal.Body>
      {/* 확인 버튼만 필요해서 공용 Footer(취소 버튼 고정 노출) 대신 직접 렌더한다.
          본문이 스크롤되므로 ModalBody 밖(ModalFooter)에 둬야 버튼이 따라 올라가지 않는다. */}
      <ModalFooter padding={"12px 16px"}>
        <AppButton variant={"primary"} width={"80px"} onClick={onClose}>
          <Text textStyle={"body-sm-bold"}>
            {t("path_pick:basket.buyer_info.example_modal.confirm")}
          </Text>
        </AppButton>
      </ModalFooter>
    </CustomApprovalModal>
  );
}

export default PathPickBasketBuyerInfoExampleModal;
